import colors from '@/assets/theme/colors/hex/index.common';
import View from '@/components/atomic/atoms/layout/view/styled';
import { DropdownContainerProps } from '@/components/atomic/atoms/utils/portals/dropdown-container/typings';
import { CSSObject } from '@emotion/react';
import styled from '@emotion/styled';

const { white } = colors;

const DropdownContainer = styled(View)<DropdownContainerProps>(({
	$backgroundColor = white.hex(),
	theme,
	$paddingTop,
	$frostedGlassBarHeight,
	hasBreadcrumbs,
}) => {
	const style: CSSObject = {
		position: 'fixed',
		left: 0,
		top: $paddingTop,
		height: '100dvh',
		width: '100dvw',
		backgroundColor: $backgroundColor,
		zIndex: 99,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: `background-color 0.3s ease`,
		paddingTop: 0,
		[theme.media.desktop.laptop]: {
			zIndex: 100,
			height: 'auto',
			maxHeight: `calc(100dvh - ${$paddingTop}px)`,
			overflowY: 'auto',
			display: 'inline-block',
			background: $frostedGlassBarHeight
				? `linear-gradient(to bottom, ${$backgroundColor}  calc(100% - ${$frostedGlassBarHeight}px), transparent ${$frostedGlassBarHeight}px)`
				: $backgroundColor,
			[`&#naas-dropdown-builds`]: {
				'&:before': {
					content: '""',
					position: 'absolute',
					boxShadow: '0 1px 4px 0 rgba(0, 0, 0, .1)',
					height: '10px',
					pointerEvents: 'none',
					right: 0,
					top: '-10px',
					width: '375px',
					zIndex: 2,
				},
				top: hasBreadcrumbs
					? `calc(${$paddingTop}px + 44px)`
					: $paddingTop,
				height: '100dvh',
				width: 375,
				left: 'auto',
				right: 0,
				zIndex: 1,
			},
			[`&#naas-dropdown-language-selector`]: {
				'&:before': {
					content: '""',
					position: 'absolute',
					boxShadow: '0 1px 4px 0 rgba(0, 0, 0, .1)',
					height: '10px',
					pointerEvents: 'none',
					right: 0,
					top: '-10px',
					width: '375px',
					zIndex: 2,
				},
				top: $paddingTop,
				width: 300,
				left: 'auto',
				right: 0,
			},
		},
		[`&.sidebar-panel`]: {
			maxWidth: 454,
			left: 'auto',
			right: 0,
			height: '100dvh',
			maxHeight: '100dvh',
			zIndex: 102,
			paddingTop: 0,
		},
	};

	return style;
});

export default DropdownContainer;
